import Axios from "axios";
import {
    SET_BUDGET_COST_LIST,
    UNSET_BUDGET_COST_LIST,
  } from "@/store/mutation-types";
import { getProjectBudgetDetailList , saveUpdateProjectBudgetDetail , getBudgetCostById , deleteProjectBudgetDetail } from "@/store/api";

// initial state
const state = {
  getBudgetCostList: [],
  getBudgetCostDetails: null,
};

// getters
const getters = {
  getBudgetCostList(state) {
    return state.getBudgetCostList;
  },
  getBudgetCostDetails(state) {
    return state.getBudgetCostDetails;
  },
};

// mutations
const mutations = {
  [SET_BUDGET_COST_LIST](state, data) {
    state.getBudgetCostList = data;
  },
  [UNSET_BUDGET_COST_LIST](state) {
    state.getBudgetCostList = [];
  },
  SET_BUDGET_COST_DETAILS(state, data) {
    state.getBudgetCostDetails = data;
  },
  UNSET_BUDGET_COST_DETAILS(state) {
    state.getBudgetCostDetails = null;
  },
};

// actions
const actions = {
  getBudgetCostList({ commit }, data = {}) {
    return new Promise((resolve, reject) => {
      Axios.post(getProjectBudgetDetailList, data)
        .then(function (response) {
          commit('SET_BUDGET_COST_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_BUDGET_COST_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },

  saveUpdateBudgetCost({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateProjectBudgetCost, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },

  getBudgetCostById({ commit }, id) {
    return new Promise((resolve, reject) => {
      Axios.get(getBudgetCostById, { params: { id } })
        .then(function (response) {
          commit('SET_BUDGET_COST_DETAILS', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_BUDGET_COST_DETAILS')
          reject(error);
        });
    });
  },

  deleteBudgetCost({ commit }, id) {
    return new Promise((resolve, reject) => {
      Axios.get(deleteProjectBudgetCost, { params: { id } })
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};